var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownChevronGrayIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99536 6.62319C5.87085 6.62319 5.75256 6.59995 5.6405 6.55346C5.53259 6.51085 5.42883 6.44113 5.32922 6.34429L0.641364 1.87598C0.483639 1.72491 0.404814 1.5409 0.404814 1.32397C0.404814 1.18452 0.442164 1.05475 0.516865 0.934669C0.591564 0.814584 0.691164 0.717739 0.815664 0.644141C0.940164 0.574414 1.08131 0.539551 1.23904 0.539551C1.46726 0.539551 1.67066 0.620898 1.84909 0.783595L5.99536 4.76382L10.1416 0.783595C10.3159 0.620898 10.5193 0.539551 10.7517 0.539551C10.9053 0.539551 11.0443 0.574414 11.1688 0.644141C11.2975 0.717739 11.3992 0.814584 11.4739 0.934669C11.5486 1.05475 11.5859 1.18452 11.5859 1.32397C11.5859 1.5409 11.5071 1.72491 11.3494 1.87598L6.6615 6.34429C6.56189 6.43726 6.45813 6.50698 6.35022 6.55346C6.24231 6.59995 6.12402 6.62319 5.99536 6.62319Z",
    fill: "#5C5C5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownChevronGrayIcon);
export default __webpack_public_path__ + "static/media/down-chevron-gray-icon.8f8cf9f76f9e77cb0321f9ebf91a9b45.svg";
export { ForwardRef as ReactComponent };